/**
 * Handler — récupération du manifeste siteAppliSFoncier via proxy backend (BL-0456).
 */
export interface U3141UseGetSiteAppliSFoncierVersionHandlersParams {
  doGetSiteAppliSFoncierVersionFn: () => Promise<{ data: unknown }>;
  onSuccess?: (versionJson: unknown) => void;
  onError?: (errors: { error: unknown }) => void;
}

export interface U3141UseGetSiteAppliSFoncierVersionHandlersReturn {
  getSiteAppliSFoncierVersion: () => Promise<void>;
}

export function useU3141GetSiteAppliSFoncierVersionHandlers({
  doGetSiteAppliSFoncierVersionFn,
  onSuccess,
  onError,
}: U3141UseGetSiteAppliSFoncierVersionHandlersParams): U3141UseGetSiteAppliSFoncierVersionHandlersReturn {
  const getSiteAppliSFoncierVersion = async () => {
    try {
      const response = await doGetSiteAppliSFoncierVersionFn();
      const data = response?.data as { result?: unknown } | unknown;
      const versionJson =
        data && typeof data === "object" && data !== null && "result" in data
          ? (data as { result: unknown }).result
          : data;
      onSuccess?.(versionJson);
    } catch (error) {
      onError?.({ error });
    }
  };

  return { getSiteAppliSFoncierVersion };
}
